// ** Initial State
const initialState = {
  allExam: [],
  papers: null,
  loading: true,
  item: [],
  questions: null,
  selectedExamName: null,
  filterQuestions:null
};

const examReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_EXAM":
      return {
        ...state,
        allExam: action.data,
        loading: action.loading,
      };
    case "UPDATE":
      return {
        ...state,
        allExam: action.data,
      };
    case "UPDATE_DATA":
      return {
        ...state,
        allExam: [...state.allExam, action.data],
      };
    case "FILTER_QUESTIONS":
      return{
        ...state,
        filterQuestions: action.payload,
        loading: action.loading,
      }
    case "UPDATE_PAPER":
      return {
        ...state,
        allExam: [...state.allExam, action.data],
      };
    case "LOADING_DATA":
      return {
        ...state,
        loading: action.loading,
      };
    case "UPDATE_EXAM":
      return {
        ...state,
        item: action.item,
      };
    case "ADD_PAPERS":
      return {
        ...state,
        papers: action.papers,
      };
    case "SELECT_EXAM":
      return {
        ...state,
        selectedExamName: action.payload,
      };
    case "DELETE_PAPERS":
      const data = [...state.allExam];
      const filterData = data.map((item) => {
        return {
          ...item,
          papers: item.papers.filter((item) => item._id !== action.data),
        };
      });
      return {
        ...state,
        allExam: filterData,
      };
    case "SET_QUESTIONS":
      return { ...state, questions: action.questions };
    default:
      return state;
  }
};

export default examReducer;
